// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27svy","col":"styles_col__11MMo"};